import { getDateWithSpecificFormat } from '../../../../data-transform';
import { getOrderTypeText, getStatusDescriptionFromStatusValue } from '../../../../../utils/utility';

export default function vendorFinancialsDirectCustomer(config) {
    if (!config.data) return null;
    const { financialList, copyOfFinancialList } = config.data;

    let result = {};
    let tableData = [];

    financialList.forEach((order, index) => {
        let row = [];
        const rowId = order.orderId + "|" + order.paymentStatus + "|" + index;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            const columnDataType = column.data.displayInBodyAs;
            let importantData = null;
            let columnValue = null;
            let columnValueData = null;
            let clickHandler = null;
            let isDisabled = false;

            if (columnDataType === "string") {
                if (columnId === "orderId" && order.orderId) {
                    columnValue = order.orderId;
                }
                else if (columnId === "company") {
                    columnValue = order.company;
                }
                else if (columnId === "orderType") {
                    columnValue = getOrderTypeText(order.orderType) || "";
                }
                else if (columnId === "collectionDate") {
                    columnValue = getDateWithSpecificFormat(order.collectionDate) || "";
                }
                else if (columnId === "amount") {
                    columnValue = order.customerAmount == null || order.customerAmount == undefined ? 0 : order.customerAmount;
                    importantData = order.customerAmount < 0 ? "NegativeAmount" : "";
                }
                else if (column.id === "currencyCode") {
                    columnValue = order.currencyCode || "";
                }
            }
            else if (columnDataType === "input") {
                columnValueData = { ...column.data };
                clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null;
                if (columnId === "customerInvoiceDate") {
                    columnValue = order.paymentDate || "";
                    columnValueData.defaultValue = columnValue;
                    columnValueData.disableBeforeDates = [order.createdDate, order.collectionDate, new Date()];
                    const copyOfSpecificOrder = copyOfFinancialList[index] ? copyOfFinancialList[index] : {};
                    if (!['PAYMENT_TO_HP_PARTNER_PENDING', 'PAYMENT_TO_CUSTOMER_PENDING', 'HARDWARE_PAYMENT_TO_CUSTOMER_PENDING','SERVICE_PAYMENT_TO_HP_PARTNER_PENDING','HARDWARE_PAYMENT_TO_CUSTOMER_ARRANGED'].includes(order.paymentStatus)) {
                        isDisabled = true;
                        if (['COMPLETED'].includes(order.paymentStatus) && !copyOfSpecificOrder['paymentDate']) {
                            isDisabled = false;
                        }
                    }
                }
            }
            else if (columnDataType === "select") {
                if (columnId === "paymentStatus") {
                    columnValue = order.paymentStatus || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    const paymentStatusDropDownOptions = [{ id: columnValue, label: columnValue === "COMPLETED" ? "Completed" : getStatusDescriptionFromStatusValue(columnValue) }];
                    if (columnValue === 'PAYMENT_TO_HP_PARTNER_PENDING') {
                        paymentStatusDropDownOptions.push({ id: "COMPLETED", label: "Completed" });
                    }
                    else if (columnValue === 'PAYMENT_TO_CUSTOMER_PENDING') {
                        paymentStatusDropDownOptions.push({ id: "COMPLETED", label: "Completed" });
                    }
                    else if (order.paymentType === 'DRV Dual Payment' && order.lineType === 'service') {
                        paymentStatusDropDownOptions.push({ id: "COMPLETED", label: "Completed" });
                    }
                    else if (order.paymentType === 'DRV Dual Payment' && order.lineType === 'service') {
                        paymentStatusDropDownOptions.push({ id: "COMPLETED", label: "Completed" });
                    }
                    else {
                        isDisabled = true;
                    }
                    columnValueData.options = paymentStatusDropDownOptions;

                    if (order.paymentType === 'DRV Dual Payment' && order.lineType === 'hardware') {
                        columnValueData.options = order.paymentStatus === 'HARDWARE_PAYMENT_TO_CUSTOMER_PENDING' ? [
                            { id: columnValue, label: getStatusDescriptionFromStatusValue(columnValue) },
                            { id: "HARDWARE_PAYMENT_TO_CUSTOMER_ARRANGED", label: getStatusDescriptionFromStatusValue('HARDWARE_PAYMENT_TO_CUSTOMER_ARRANGED') },
                            { id: "COMPLETED", label: getStatusDescriptionFromStatusValue('COMPLETED') }
                        ] :
                            [
                                { id: columnValue, label: getStatusDescriptionFromStatusValue(columnValue) },
                                { id: "COMPLETED", label: getStatusDescriptionFromStatusValue('COMPLETED') }
                            ]
                        isDisabled = false;
                    }
                    else if (order.paymentType === 'DRV Dual Payment' && order.lineType === 'service') {
                        columnValueData.options = order.paymentStatus === 'SERVICE_PAYMENT_TO_HP_PARTNER_PENDING' ?
                            [{ id: columnValue, label: getStatusDescriptionFromStatusValue(columnValue) },
                            { id: "COMPLETED", label: getStatusDescriptionFromStatusValue('COMPLETED') }] :
                            [{ id: "COMPLETED", label: getStatusDescriptionFromStatusValue('COMPLETED') }]
                        isDisabled = false;
                    }
                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null
                }
            }

            row.push({
                [columnId]: {
                    id: columnId + "|" + rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValueData || columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    disabled: isDisabled,
                    showInMobileViewAs: column.showInMobileViewAs,
                    importantData: importantData,
                    clickHandler: clickHandler
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}
